
export * from '../../frontend-taglib-clay/__liferay__/exports/@clayui$button.js';

import __default__ from '../../frontend-taglib-clay/__liferay__/exports/@clayui$button.js';
export default __default__;
